import { Button, Tooltip } from "@material-ui/core";
import React, { useState } from "react";

import { Box } from "../../../../../dtos/box";
import { BoxFeature } from "../types";

import { LeaseEndDateEditDialog } from "./LeaseEndDateEditDialog";

interface Props {
    box: Box
    onLeaseEndDateSaved: () => void;
    feature: BoxFeature;
}

export function LeaseEndDateEditButton({
    box,
    onLeaseEndDateSaved,
    feature,
}: Props) {
    const [openDialog, setOpenDialog] = useState(false);

    return (<>
        <Tooltip title={feature.reason}>
            <span>
                <Button
                    onClick={() => setOpenDialog(true)}
                    variant="contained"
                    color="primary"
                    disabled={!feature.enabled}
                >
                    Edit Lease End Date
                </Button>
            </span>
        </Tooltip>
        <LeaseEndDateEditDialog
            key={`${openDialog}`}
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            box={box}
            onLeaseEndDateSaved={onLeaseEndDateSaved}
        />
    </>);
}
